import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { listView, isMobileMode, isRecurring } = {}) => ({
    plusButton: { marginLeft: 16 },
    productsHeader: {
      marginTop: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        marginTop: isRecurring ? theme.spacing(2) : theme.spacing(4),
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(4),
      },
    },
    productsLayout: listView
      ? {
          display: 'flex',
          flexDirection: 'column',
          gridTemplateColumns: 'initial',
          gap: theme.spacing(2),
        }
      : {
          display: 'grid',
          gridTemplateColumns: isMobileMode ? '1fr 1fr' : '1fr 1fr 1fr',
          gap: theme.spacing(2),
        },
    gridCard: {
      [theme.breakpoints.down('lg')]: {
        height: '410px !important',
      },
      [theme.breakpoints.down('md')]: {
        height: isRecurring ? '270px !important' : '250px !important',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          height: '410px !important',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          height: isRecurring ? '270px !important' : '250px !important',
        }),
      },
    },
  }),
);
